import { AlignmentType, Document, Paragraph, TextRun, TabStopType, TabStopPosition } from "docx";

export class DocumentCreator {
  create(meeting, acceptedAttendees, declinedAttendees) {
    const document = new Document({
      creator: "E-meeting",
      styles: {
        paragraphStyles: [
          {
            id: "docTitle",
            name: "Doc Title",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              bold: true,
              size: 34,
              italics: false,
              color: "black",
              font: "TH SarabunPSK"
            },
          },
          {
            id: "docBody",
            name: "Doc Body",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              bold: false,
              size: 32,
              italics: false,
              color: "black",
              font: "TH SarabunPSK"
            },
          },
          {
            id: "docBodyBold",
            name: "Doc Body Bold",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              bold: true,
              size: 32,
              italics: false,
              color: "black",
              font: "TH SarabunPSK"
            },
          },
        ],
      },
    })

    document.addSection({
      children: [
        new Paragraph({
          text: `รายงานการประชุม`,
          alignment: AlignmentType.CENTER,
          style: "docTitle",
        }),
        new Paragraph({
          text: `คณะ${meeting.title}`,
          alignment: AlignmentType.CENTER,
          style: "docTitle",
        }),
        new Paragraph({
          text: meeting.year,
          alignment: AlignmentType.CENTER,
          style: "docTitle"
        }),
        new Paragraph({
          text: meeting.date,
          alignment: AlignmentType.CENTER,
          style: "docTitle"
        }),
        new Paragraph({
          text: meeting.location,
          alignment: AlignmentType.CENTER,
          style: "docTitle"
        }),
        new Paragraph({
          text: '.......................................................................',
          alignment: AlignmentType.CENTER,
        }),
        ...this.generateAttendees(acceptedAttendees, 'ผู้มาประชุม'),
        ...this.generateAttendees(declinedAttendees, 'ผู้ไม่มาประชุม'),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({
          text: `ผู้เข้าร่วมประชุม`,
          alignment: AlignmentType.LEFT,
          style: "docTitle"
        }),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({
          text: `เริ่มการประชุม ${meeting.timeStart} น.`,
          alignment: AlignmentType.LEFT,
          style: "docTitle"
        }),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({
          text: `เลิกประชุมเวลา ${meeting.timeEnd} น.`,
          alignment: AlignmentType.LEFT,
          style: "docTitle"
        }),
      ],
    });

    return document;
  }

  generateAttendees(attendees, title)  {
    let paragraphs = []

    if(attendees.length > 0)  {
      paragraphs.push(
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({}),
        new Paragraph({
          text: title,
          alignment: AlignmentType.LEFT,
          style: "docBodyBold",
        })
      )
    }

    attendees.map((attendee, index) => {
      paragraphs.push(
        new Paragraph({
          alignment: AlignmentType.Left,
          style: "docBody",
          spacing: {
            after: 120,
            before: 120
          },
          children: [
            new TextRun({
              text: `${index + 1}. ${attendee.emailAddress.name}`,
            }),
            new TextRun({
              text: `\t\t\t\t\t\t\t${attendee.position}`,
            }),
          ],
        })
      )
    })

    return paragraphs
  }
}